import { render, staticRenderFns } from "./ProcurementRFMItemDeliveryData.vue?vue&type=template&id=04e93384&"
import script from "./ProcurementRFMItemDeliveryData.vue?vue&type=script&lang=js&"
export * from "./ProcurementRFMItemDeliveryData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports